import { SVGProps } from 'react';

export const ErrorIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      {...props}
    >
      <g clipPath="url(#clip0_26388_15038)">
        <path
          id="Vector"
          d="M20 10C20 15.5241 15.5225 20 10 20C4.47754 20 0 15.5241 0 10C0 4.47915 4.47754 0 10 0C15.5225 0 20 4.47915 20 10ZM10 12.0161C8.97561 12.0161 8.14516 12.8466 8.14516 13.871C8.14516 14.8954 8.97561 15.7258 10 15.7258C11.0244 15.7258 11.8548 14.8954 11.8548 13.871C11.8548 12.8466 11.0244 12.0161 10 12.0161ZM8.23899 5.34895L8.5381 10.8328C8.5521 11.0894 8.76427 11.2903 9.02125 11.2903H10.9788C11.2357 11.2903 11.4479 11.0894 11.4619 10.8328L11.761 5.34895C11.7761 5.07177 11.5554 4.83871 11.2779 4.83871H8.7221C8.44452 4.83871 8.22387 5.07177 8.23899 5.34895Z"
          fill="#BC3D19"
        />
      </g>
      <defs>
        <clipPath id="clip0_26388_15038">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
